import ResistanceIcon from "./ResistanceIcon";

export default ResistanceIcon;
export { ResistanceIcon };
